import PaymentStatusEnum from "@/enum/paymentStatusEnum";
import PaymentTypeEnum from "@/enum/paymentTypeEnum";
import ExportStatusEnum from "@/enum/exportStatusEnum";
import PackageTypeEnum from "@/enum/packageTypeEnum";
import BookingStatusEnum from "@/enum/bookingStatusEnum";
import ApartmentStatusEnum from "@/enum/apartmentStatusEnum";
import ContractStatusEnum from "@/enum/contractStatusEnum";
import RealestateTypeEnum from "@/enum/realestateTypeEnum";
import RelativeRelationshipEnum from "@/enum/relativeRelationshipEnum";

// Case Priority Type
const priorityTypes = [
  { value: 1, text: "Critical" },
  { value: 2, text: "High" },
  { value: 3, text: "Medium" },
  { value: 4, text: "Low" }
];

// Case Status Type
const statusTypes = [
  { value: 1, text: "case.new" },
  { value: 2, text: "case.assign" },
  { value: 3, text: "case.inprogress" },
  { value: 4, text: "case.resolve" },
  { value: 5, text: "case.pending" },
  { value: 6, text: "case.cancel" },
  { value: 7, text: "case.close" },
  { value: 8, text: "case.open" }
];

// Application Type
const applicationTypes = [
  { value: 1, text: "CONASI Webadmin" },
  { value: 2, text: "CONASI Mobile" }
];

// Maintaince Type
const maintainceTypes = [
  { text: "---", value: null },
  { text: "Bảo Trì Không Có Kế Hoạch", value: 1 },
  { text: "Bảo Trì Có Kế Hoạch", value: 2 }
];

// Maintaince Sub Type
const maintainanceSubType = [{ text: "---", value: null }];

// Email
const emailConfigure = {
  // 10mb = 10485760 byte
  max_file_size: {
    size: 10485760,
    text: "10mb"
  },
  max_file_size_attach: {
    size: 3145728,
    text: "3mb"
  },
  // 20mb = 15728640 byte
  max_total_file_size: {
    size: 20971520,
    text: "20mb"
  },
};

//Maintaince Sub Type 1
const maintainanceSubType1 = [
  { text: "---", value: null },
  { text: "Bảo trì phục hồi", value: 1 },
  { text: "Bảo trì khẩn cấp", value: 2 }
];

//Maintaince Sub Type 2
const maintainanceSubType2 = [
  { text: "---", value: null },
  { text: "Bảo trì phòng ngừa", value: 3 },
  { text: "Bảo trì phục hồi", value: 4 },
  { text: "Bảo trì cải tiến", value: 5 }
];

//Maintaince Repeat Option
const maintainanceRepeatOption = [
  { text: "---", value: null },
  { text: "Một Lần Duy Nhất", value: 1 },
  { text: "Theo Tháng", value: 2 },
  { text: "Theo Quý", value: 3 },
  { text: "Theo Năm", value: 4 }
];

// Resident Status
const residentStatusOptions = [
  { text: "---", value: null },
  { text: "Đang Ở", value: 1 },
  { text: "Đã Đi", value: 2 }
];

// Resident Relationship Type
const relationshipOptions = [
  { text: "---", value: null },
  { text: "customer.relationship.grandpa", value: RelativeRelationshipEnum.GRANDPA },
  { text: "customer.relationship.grandma", value: RelativeRelationshipEnum.GRANDMA },
  { text: "customer.relationship.father", value: RelativeRelationshipEnum.FATHER },
  { text: "customer.relationship.mother", value: RelativeRelationshipEnum.MOTHER },
  { text: "customer.relationship.child", value: RelativeRelationshipEnum.CHILD },
  { text: "customer.relationship.wife", value: RelativeRelationshipEnum.WIFE },
  { text: "customer.relationship.husband", value: RelativeRelationshipEnum.HUSBAND },
  { text: "customer.relationship.daughter", value:RelativeRelationshipEnum.DAUGHTER },
  { text: "customer.relationship.son", value:RelativeRelationshipEnum.SON },
  { text: "customer.relationship.grandchild", value: RelativeRelationshipEnum.GRANDCHILD },
  { text: "customer.relationship.older_sister", value: RelativeRelationshipEnum.OLDER_SISTER },
  { text: "customer.relationship.older_brother", value: RelativeRelationshipEnum.OLDER_BROTHER },
  { text: "customer.relationship.younger_sister", value: RelativeRelationshipEnum.YOUNGER_SISTER },
  { text: "customer.relationship.younger_brother", value: RelativeRelationshipEnum.YOUNGER_BROTHER }
];

// Gender list
const genderTypes = [
  { id: null, text: "---" },
  { id: 1, text: "customer.gender_type[0]" },
  { id: 2, text: "customer.gender_type[1]" },
  { id: 3, text: "customer.gender_type[2]" }
];

// Gender list
const paymentsType = [
  { id: PaymentTypeEnum.CASH, text: "payments.payments_type[0]" },
  { id: PaymentTypeEnum.BANK_TRANSFER, text: "payments.payments_type[1]" },
  { id: PaymentTypeEnum.CARD, text: "payments.payments_type[2]"},
  { id: PaymentTypeEnum.OTHER, text: "payments.payments_type[3]"}
];

const headerImport = [
  "ApartmentCode",
  "LastMonthValue",
  "ThisMonthValue",
  "DateFrom",
  "DateTo"
];

const calculateMonthlyUsage = {
  calculate_monthly_usage_start: 26, // From 26 June
  calculate_monthly_usage_end: 25 // To 25 July
};

const enterMonthlyUsage = {
  enter_monthly_usage_start: 25, //# Begin input from 25 July
  enter_monthly_usage_end: 24 //# End input from 24 August
};

const dateOptions = {
  format: "DD/MM/YYYY",
  format_date_time: "DD/MM/YYYY hh:mm:ss"
};

const dateOptionList = [
  { id: 1, format: "DD/MM/YYYY" },
  { id: 2, format: "DD-MM-YYYY" }
];

const booleanOptions = [
  { value: false, text: "False" },
  { value: true, text: "True" }
];

// Project status type
import ProjectStatusEnum from "@/enum/projectStatusEnum";
const projectStatusType = [
  { id: ProjectStatusEnum.ACTIVE, text: "project.status[0]" },
  { id: ProjectStatusEnum.PENDING, text: "project.status[1]" },
  { id: ProjectStatusEnum.CLOSED, text: "project.status[2]" }
];

const actionTypes = [
  { id: 0, text: "project_history.action_description[0]" },
  { id: 1, text: "project_history.action_description[1]" },
  { id: 2, text: "project_history.action_description[2]" }
];

import InvoiceTemplateEnum from "../enum/invoiceTemplateEnum"
const invoiceTemplateList = [
  { id: InvoiceTemplateEnum.REPUBLIC_PALAZA, text: "Republic Template" },
  { id: InvoiceTemplateEnum.ARIZANA_CONDOTEL, text: "Ariyana Template" }
];

const password_default = {
  password: "Abc@1234"
};

const discountTypeCode = [
  { id: "cash", text: "discountType.discount[0]" },
  { id: "perc", text: "discountType.discount[1]" }
];
const serviceCouponStatus = [
  // {id: 0, text: 'servicecouponstatus.status[0]'},
  { id: 1, text: "servicecouponstatus.status[1]" },
  { id: 2, text: "servicecouponstatus.status[2]" },
  { id: 3, text: "servicecouponstatus.status[3]" }
];

// Maintaince Type
const paymentDurationFactor = [
  { text: "Tháng", value: 1 },
  { text: "Tuần", value: 2 },
  { text: "Ngày", value: 3 }
];

// Cleaning Service
const cleaningService = [
  { text: "Dọn Phòng (Có Người)", value: 1 },
  { text: "Dọn Phòng (Phòng Trống)", value: 2 },
  { text: "Đã Dọn", value: 3 },
  { text: "Kiểm Kê (Checkin)", value: 4 },
  { text: "Kiểm Kê (Checkout)", value: 5 },
  { text: "Đã Kiểm Tra", value: 6 }
];

const basicServices = [
  { text: "electric", value: 1 },
  { text: "water", value: 2 }
];

const bookingStatusCode = [
  // {id: 0, text: 'servicecouponstatus.status[0]'},
  { id: BookingStatusEnum.WAITING, text: "apartment.reservations.waiting" },
  { id: BookingStatusEnum.CONFIRMED, text: "apartment.reservations.confirmed" },
  { id: BookingStatusEnum.RESERVED, text: "apartment.reservations.reserved" },
  { id: BookingStatusEnum.DEPOSIT, text: "apartment.reservations.deposit" },
  { id: BookingStatusEnum.PAID, text: "apartment.reservations.paid" },
  { id: BookingStatusEnum.CANCELLED, text: "apartment.reservations.cancelled" },
  { id: BookingStatusEnum.PENDING, text: "apartment.reservations.pending" },
  { id: BookingStatusEnum.ONBOARD, text: "apartment.reservations.onboard" },
  { id: BookingStatusEnum.EXPIRED, text: "apartment.reservations.expired" },
  { id: BookingStatusEnum.CHECKOUT, text: "apartment.reservations.checkedout" },
  { id: BookingStatusEnum.CHECKINCOMMINGSOON, text: "apartment.reservations.checkin_comming_soon" },
  { id: BookingStatusEnum.CHECKOUTCOMMINGSOON, text: "apartment.reservations.checkout_comming_soon" }
];

const timeZone = {
  Vietnamese: "Asia/Ho_Chi_Minh"
};

const assetUnitMeasure = [
  {
    id: 1,
    text: "property.asset.unit_measure"
  },
  {
    id: 2,
    text: "property.asset.set_measure"
  }
];
const RewardPoint = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum'
}

const serviceList = [
  { text: "common.serviceName.electric", id: 1 },
  { text: "common.serviceName.water", id: 2 },
  { text: "common.serviceName.managementService", id: 7 }
];

import feedbackStatusEnum from "../enum/feedbackStatusEnum"
const feedbackStatusList = [
  { value: feedbackStatusEnum.CREATE, text: "feedback.statusList.new" },
  { value: feedbackStatusEnum.RECEIVED, text: "feedback.statusList.received" },
  { value: feedbackStatusEnum.DONE, text: "feedback.statusList.done" },
  { value: feedbackStatusEnum.CANCELED, text: "feedback.statusList.canceled" },
  { value: feedbackStatusEnum.IN_PROGRESS, text: "feedback.statusList.doing" },
  { value: feedbackStatusEnum.IN_PROGRESS_DOING, text: "feedback.statusList.doing" },
  { value: feedbackStatusEnum.IN_PROGRESS_DONE, text: "feedback.statusList.doing" },
  { value: feedbackStatusEnum.IN_PROGRESS_CANCEL, text: "feedback.statusList.doing" }
]

const serviceTypeList = [
  { value: 1, text: "service.serviceTypeList.fixedService"},
  { value: 2, text: "service.serviceTypeList.nonFixedService"},
  { value: 3, text: "service.serviceTypeList.allServiceType"},
]

const serviceAttributeTypeList = [
  { value: 1, text: "service.serviceAttributeTypeList.times"},
  { value: 2, text: "service.serviceAttributeTypeList.hour"},
  { value: 3, text: "service.serviceAttributeTypeList.date"},
  { value: 4, text: "service.serviceAttributeTypeList.month"}
]

const apartmentTypePriceTypeList = [
  { value: 1, text: "configuration.apartmentTypePrice.apartmentTypePriceTypeList.date"}
]

const apartmentBookingStatusList = [
  { value: 1, text: "apartmentBooking.statusList.waitingCheckIn" },
  { value: 2, text: "apartmentBooking.statusList.cancel" },
  { value: 3, text: "apartmentBooking.statusList.checkedIn" },
  { value: 4, text: "apartmentBooking.statusList.checkOut" }
]

const roomPerformanceReportDateList = [
  { value: 7, text: "roomPerformanceReport.numberDateGroupList.7Date" },
  { value: 15, text: "roomPerformanceReport.numberDateGroupList.15Date" },
  { value: 30, text: "roomPerformanceReport.numberDateGroupList.30Date" }
]

const maintenanceCycleList = [
  { value: 1, text: "property.asset.maintenanceCycleList.1Month"},
  { value: 3, text: "property.asset.maintenanceCycleList.3Month"},
  { value: 6, text: "property.asset.maintenanceCycleList.6Month"},
  { value: 9, text: "property.asset.maintenanceCycleList.9Month"},
  { value: 12, text: "property.asset.maintenanceCycleList.12Month"}
]

import Enum from "../../enum/enum";
const maintenanceStatusList = [
  { value: Enum.MaintenanceStatusEnum.MAINTENANCE_TRACKING, text: "propertyMaintenance.statusList.tracking"},
  { value: Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING, text: "propertyMaintenance.statusList.planning"},
  { value: Enum.MaintenanceStatusEnum.MAINTENANCE_IN_PROCESSING, text: "propertyMaintenance.statusList.processing"},
  { value: Enum.MaintenanceStatusEnum.MAINTENANCE_FINISHED, text: "propertyMaintenance.statusList.completed"},
  { value: Enum.MaintenanceStatusEnum.MAINTENANCE_CANCELED, text: "propertyMaintenance.statusList.canceled"},
]

const serviceHistoryAction = [
  { value: Enum.ActionHistoryEnum.CREATE, text: "service.historyAction.create" },
  { value: Enum.ActionHistoryEnum.UPDATE, text: "service.historyAction.update" },
  { value: Enum.ActionHistoryEnum.DELETE, text: "service.historyAction.delete" }
]

const servicePackageHistoryAction = [
  { value: Enum.ActionHistoryEnum.CREATE, text: "service.servicePackage.historyAction.create" },
  { value: Enum.ActionHistoryEnum.UPDATE, text: "service.servicePackage.historyAction.update" },
  { value: Enum.ActionHistoryEnum.DELETE, text: "service.servicePackage.historyAction.delete" }
]

const paymentStatusText = [
  { id: PaymentStatusEnum.CHECKIN, name: "service.historyAction.create" },
  { id: PaymentStatusEnum.LIABILITY, name: "service.historyAction.create" },
  { id: PaymentStatusEnum.PAID, name: "service.historyAction.create" },
  { id: PaymentStatusEnum.ISSUED, name: "service.historyAction.create" }
]

const depositOptionsText = [
  { id: false, text: "apartmentbookings.paymentBooking.depositoptionList.n" },
  { id: true, text: "apartmentbookings.paymentBooking.depositoptionList.y" }
];

const exportStatusText = [
  { id: ExportStatusEnum.NOT_EXPORT, text: "apartmentbookings.paymentBooking.exportoptionList.not_export" },
  { id: ExportStatusEnum.IN_EXPORT, text: "apartmentbookings.paymentBooking.exportoptionList.in_export" },
  { id: ExportStatusEnum.POST_EXPORT, text: "apartmentbookings.paymentBooking.exportoptionList.post_export" }
];

const packageTypeText = [
  { id: PackageTypeEnum.LUXURY, text: "service.package.luxury" },
  { id: PackageTypeEnum.DELUXE, text: "service.package.deluxe" },
  { id: PackageTypeEnum.PREMIUM, text: "service.package.premium" },
  { id: PackageTypeEnum.STANDARD, text: "service.package.standard" }
];

const apartmentStatusText = [
  { id: ApartmentStatusEnum.NOT_HANDOVER, text: "apartment_status.not_handover" },
  { id: ApartmentStatusEnum.HANDOVER, text: "apartment_status.handover" },
  { id: ApartmentStatusEnum.OCCUPIED, text: "apartment_status.occupied" }
  // { id: ApartmentStatusEnum.NOT_RENTED, text: "apartment_status.not_rented" }
  // { id: ApartmentStatusEnum.RENTED, text: "apartment_status.rented" }
];

const contractStatusText = [
  { id: ContractStatusEnum.BOOK, text: "contract.status_book" },
  { id: ContractStatusEnum.DEPOSIT, text: "contract.status_deposit" },
  { id: ContractStatusEnum.CONTRACT, text: "contract.status_contract" },
  { id: ContractStatusEnum.END_CONTRACT, text: "contract.status_end_contract" }
]

const realestateTypeText = [
  { value: RealestateTypeEnum.VILLA, text: "apartment_realestate.class.villa" },
  { value: RealestateTypeEnum.APARTMENT, text: "apartment_realestate.class.apartment" },
  { value: RealestateTypeEnum.GROUND, text: "apartment_realestate.class.ground" }
]

export default {
  paymentsType,
  actionTypes,
  priorityTypes,
  statusTypes,
  applicationTypes,
  maintainceTypes,
  maintainanceSubType,
  maintainanceSubType1,
  maintainanceSubType2,
  maintainanceRepeatOption,
  residentStatusOptions,
  relationshipOptions,
  headerImport,
  genderTypes,
  calculateMonthlyUsage,
  enterMonthlyUsage,
  dateOptions,
  booleanOptions,
  dateOptionList,
  invoiceTemplateList,
  projectStatusType,
  password_default,
  discountTypeCode,
  serviceCouponStatus,
  paymentDurationFactor,
  basicServices,
  timeZone,
  assetUnitMeasure,
  bookingStatusCode,
  cleaningService,
  emailConfigure,
  RewardPoint,
  serviceList,
  feedbackStatusList,
  serviceTypeList,
  serviceAttributeTypeList,
  apartmentTypePriceTypeList,
  apartmentBookingStatusList,
  roomPerformanceReportDateList,
  maintenanceCycleList,
  maintenanceStatusList,
  serviceHistoryAction,
  servicePackageHistoryAction,
  paymentStatusText,
  depositOptionsText,
  exportStatusText,
  packageTypeText,
  apartmentStatusText,
  contractStatusText,
  realestateTypeText
};



// WEBPACK FOOTER //
// ./src/lib/constantsData.js